import { Button } from "@vds/buttons";
import { Row } from '@vds/grids';
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Cell, TableHeader } from "@vds/tables";
import { Body, Title } from "@vds/typography";
import { MarginSpacerM } from "common/components/styleTag";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from 'styled-components';

function PlansFirstDevicesApplyModal(props) {
    const { t } = useTranslation(["plans"]);
    const planFirstPageData = useSelector((state) => state.PlanFirst);

    // const isMobile = useMediaQuery({
    //     query: "(max-width: 545px)",
    // });
    // const titleText = planFirstPageData.linesCount === planFirstPageData?.linesRemain ? `Apply this device to all ${planFirstPageData?.linesCount} lines?`
    //     : `Apply this devie to ${planFirstPageData?.linesRemain > 0 ? planFirstPageData?.linesRemain : ''} remaining lines?`

    let title = ""
    let moreDevicesText = ""
    if(props.handleAddMoreDevices) {
        title = "Your additional device(s) will be added to the selected plan."
        moreDevicesText = "Any changes can be edited in the cart."
    } else {
         title = props.selectedQuantity > 1 && planFirstPageData?.linesRemain - props.selectedQuantity > 0 
        ? `Apply this device to ${planFirstPageData?.linesRemain - props.selectedQuantity} remaining lines?`
        : props.selectedQuantity > 1 && planFirstPageData?.linesRemain - props.selectedQuantity < 0
                ? `Your additional device(s) will be added to the selected plan.`
                //`Selected number of devices are more than the remaining lines. ${props.selectedQuantity - planFirstPageData?.linesRemain} ${props.selectedQuantity - planFirstPageData?.linesRemain > 1 ? 'lines' : 'line'} will be added.`
                    : planFirstPageData.linesCount === planFirstPageData?.linesRemain ? `Apply this device to all ${planFirstPageData?.linesCount} lines?`
                    : `Apply this device to ${planFirstPageData?.linesRemain > 0 ? planFirstPageData?.linesRemain : ''} remaining lines?`
                    
 moreDevicesText = props.selectedQuantity > 1 && planFirstPageData?.linesRemain - props.selectedQuantity < 0
                        ? "Any changes can be edited in the cart." : ""                        
    }
   

    return (
        <Modal hideCloseButton={true}
            disableOutsideClick={true}
            onOpenedChange={(e) => {
                if (!e) {
                    props.closeModal(null)
                }
            }
            }
            opened={!!props.showModal}
            data-track='close'>
            <ModalTitle>
                <Title size="large" bold={true}>{title}</Title>
            </ModalTitle>
            <ModalBody>
                { moreDevicesText && <>
                <Body size="large">{moreDevicesText}</Body>
                <MarginSpacerM /></>}
                <Buttons addSmartPhoneToCart={props?.addSmartPhoneToCart} linesCount={planFirstPageData?.linesCount} linesRemain={planFirstPageData?.linesRemain} 
                            selectedQuantity={props.selectedQuantity} applyToAllLines={props?.applyToAllLines} applyToOneLine={props?.applyToOneLine} 
                            closeModal={props?.closeModal} fromByod={props.fromByod} onClickImeifinalizeMultipleSimSelection={props.onClickImeifinalizeMultipleSimSelection}
                            handleAddMoreDevices={props.handleAddMoreDevices} increaseLinesCount={props.increaseLinesCount}/>
            </ModalBody>
        </Modal>

    );
}

const Buttons = (props) => {
    const { t } = useTranslation(["plans-first-new"]);
    let primaryButton = ""
    let secondaryButton = ""
    if (props.handleAddMoreDevices) {
        primaryButton = "Continue"
        secondaryButton = "Go back"
    } else {
        primaryButton = props.selectedQuantity > 1 && props?.linesRemain - props.selectedQuantity > 0
            ? `Apply to ${props?.linesRemain} lines`
            : props.selectedQuantity > 1 && props?.linesRemain - props.selectedQuantity < 0
                ? `Continue`
                : props.linesCount === props?.linesRemain
                    ? `${t("plans-first-new.buttons.applyToAllLines", { ns: "plans-first-new" })}`
                    : `Apply to ${props?.linesRemain} lines`

        secondaryButton = props.selectedQuantity > 1 && props?.linesRemain - props.selectedQuantity < 0
            ? `Go back` : `${t("plans-first-new.buttons.moreDevices", { ns: "plans-first-new" })}`
    }

    const continueWithMoreDevices = () => {
        props.handleAddMoreDevices()
        props.increaseLinesCount() 
    }

    return (
        <ButtonContainer>
            <StyledButton
                onClick={() => {
                    props.closeModal()
                    props.fromByod ? continueWithMoreDevices() : props.applyToAllLines()
                }}
            >
                {/* {props?.linesCount === props?.linesRemain ? `${t("plans-first-new.buttons.applyToAllLines", { ns: "plans-first-new" })}` : `Apply to ${props?.linesRemain} lines`}  */}
                {primaryButton}
            </StyledButton>
            <StyledButton
                use="secondary"
                size="medium"
                onClick={() => { 
                    props.closeModal()
                    props.fromByod || (props.selectedQuantity > 1 && props?.linesRemain - props.selectedQuantity < 0) ? '' : props.applyToOneLine() 
                }}
            >
                {/* {t("plans-first-new.buttons.moreDevices", { ns: "plans-first-new" })} */}
                {secondaryButton}

            </StyledButton>
        </ButtonContainer>
    );

}

const ButtonContainer = styled.div`
display:flex;
flex-direction:column;
padding-top:1.5rem;
align-items:center;
gap:1rem;
@media only screen and (min-width:768px){
    flex-direction:row;
}
`;

const TitleText = styled(Title)`
font-size:32px;
line-height:36px;
`

const StyledButton = styled(Button)`
width:226px;
height:44px;
span {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
@media only screen and (max-width:767px){
    padding:8px 0px;
    width:100%;
}
; `

export const StyledCell = styled(Cell)`
padding: 16px 32px 16px 12px !important;
@media screen and (max-width:767px){
    padding: 12px 0px 12px 12px !important;
  }
`;

export const BgStyledCell = styled(Cell)`
padding: 16px 32px 16px 12px !important;
background-color : #f6f6f6;
@media screen and (max-width:767px){
    padding: 12px 0px 12px 12px !important;
  }
`;

export const StyledTableHeader = styled(TableHeader)`
padding: 16px 32px 16px 12px !important;
@media screen and (max-width:767px){
    padding: 12px 0px 12px 12px !important;
  }
`;
export const BgTableHeader = styled(TableHeader)`
padding: 16px 32px 16px 12px !important;
background-color : #f6f6f6;
@media screen and (max-width:767px){
    padding: 12px 0px 12px 12px !important;
  }
`;

export const RowNoPad = styled(Row)`
  padding: 0 !important;
`;

const ModalDeviceContainer = styled.div`
 height:100%;
 [class^=StyledFooter-VDS]{
    padding:0 0 48px 0 !important;
 }
}
`;

export default PlansFirstDevicesApplyModal
